export default __webpack_public_path__ + "static/media/Turkey-vs-Italy.6532c5f2.jpeg";